import { Filter, defaultVertex } from '@pixi/core';
import fragment from './alpha.mjs';

class AlphaFilter extends Filter {
  constructor(alpha = 1) {
    super(defaultVertex, fragment, { uAlpha: 1 });
    this.alpha = alpha;
  }
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(value) {
    this.uniforms.uAlpha = value;
  }
}

export { AlphaFilter };
//# sourceMappingURL=AlphaFilter.mjs.map
